import { Theme } from "@mui/material";
import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme: Theme) => ({
  root: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "16px",
    height: "42px",
  },
  actions: {
    display: "flex",
    alignItems: "center",
    gap: "16px",
  },
  iconButton: {
    width: "42px",
    height: "42px",
    padding: 0,
  },
  search: {
    width: "280px",
    "& .MuiOutlinedInput-root": {
      height: "42px",
      borderRadius: "4px",
      background: theme.palette.background.paper,
      direction: "ltr",
      padding: "0 8px",
      "& fieldset": {
        borderColor: theme.palette.divider,
      },
    },
    "& .MuiOutlinedInput-input": {
      padding: "5px 8px",
      fontSize: "13px",
      color: theme.palette.text.secondary,
      textAlign: "right",
      direction: "rtl",
      fontFamily: "Noto Sans Hebrew",
    },
    "& .MuiOutlinedInput-input::placeholder": {
      color: theme.palette.text.secondary,
      opacity: 0.7,
      textAlign: "right",
    },
  },
  searchIcon: {
    fontSize: "26px !important",
    color: theme.palette.text.secondary,
    marginRight: "6px",
    transform: "scaleX(-1)",
  },
}));
